import type {
  ComponentPropsWithoutRef,
  ReactNode,
  SubmitEventHandler,
} from "react";

import {
  DefaultFormBackButton,
  DefaultFormContainer,
  DefaultFormTitle,
  DefaultFormTitleContainer,
} from "../styles/DefaultFormStyles";

type DefaultFormProps = Omit<
  ComponentPropsWithoutRef<"form">,
  "onSubmit" | "title"
> & {
  title?: string;
  returnPath?: string;
  children: ReactNode;
  onSubmit: SubmitEventHandler<HTMLFormElement>;
  testId: string;
  noPadding?: boolean;
};

export const DefaultForm = ({
  title,
  returnPath,
  children,
  onSubmit,
  testId,
  noPadding = false,
  ...formProps
}: DefaultFormProps) => {
  const titleId = title ? `${testId}-title` : undefined;

  return (
    <DefaultFormContainer
      {...formProps}
      $noPadding={noPadding}
      onSubmit={onSubmit}
      data-testid={testId}
      aria-labelledby={titleId}
    >
      {(title || returnPath) && (
        <DefaultFormTitleContainer>
          {returnPath && (
            <DefaultFormBackButton
              to={returnPath}
              aria-label="Voltar"
            />
          )}

          {title && (
            <DefaultFormTitle id={titleId} variant="h1">
              {title}
            </DefaultFormTitle>
          )}
        </DefaultFormTitleContainer>
      )}

      {children}
    </DefaultFormContainer>
  );
};